import { render, staticRenderFns } from "./VehicleCreate.vue?vue&type=template&id=4f23c0ec"
import script from "./VehicleCreate.vue?vue&type=script&lang=js"
export * from "./VehicleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports